import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["label", "dataTestId", "disabled", "onClick", "tooltip", "tooltipPlacement", "tooltipUse", "showNewBadge"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBadge from 'UIComponents/badge/UIBadge';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ActionButton = _ref => {
  let {
      label,
      dataTestId,
      disabled,
      onClick,
      tooltip,
      tooltipPlacement = 'left bottom',
      tooltipUse = 'default',
      showNewBadge
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    size,
    use
  } = buttonProps;
  const dataTestIdButtonProp = buttonProps['data-test-id'];
  const buttonDataTestId = dataTestId || dataTestIdButtonProp;
  return /*#__PURE__*/_jsx(UITooltip, {
    disabled: !disabled,
    title: tooltip,
    use: tooltipUse,
    placement: tooltipPlacement,
    children: /*#__PURE__*/_jsxs(UIButton, {
      disabled: disabled,
      onClick: onClick,
      "data-test-id": buttonDataTestId,
      use: use,
      size: size,
      children: [label, showNewBadge && /*#__PURE__*/_jsx(UIBadge, {
        use: "new",
        className: "m-left-1",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.newBadge"
        })
      })]
    })
  });
};
ActionButton.propTypes = {
  dataTestId: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  onClick: PropTypes.func.isRequired,
  tooltip: PropTypes.node,
  tooltipUse: PropTypes.string,
  tooltipPlacement: PropTypes.string,
  showNewBadge: PropTypes.bool
};
export default ActionButton;